import { faCircleExclamation } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useSelector } from 'react-redux'
import { useDispatch } from 'react-redux'
import { Modal, ModalBody, ModalFooter } from 'reactstrap'
import { setShowAlertModal } from 'store/Recruitment/actions'

function AlertModal() {
  const dispatch = useDispatch()

  const { showAlertModal } = useSelector((store) => store.recruitment)

  return (
    <Modal
      isOpen={showAlertModal.show}
      toggle={() => dispatch(setShowAlertModal({ show: false }))}
      size='md'
      centered
      scrollable
    >
      <ModalBody className='scrollbar justify-content-center text-center'>
        <FontAwesomeIcon
          icon={faCircleExclamation}
          size='4x'
          className='text-warning'
        />
        <h3 className='mt-5'>{showAlertModal.text}</h3>
      </ModalBody>
      <ModalFooter>
        <div
          className='d-flex w-100 justify-content-end'
          style={{ gap: '1.5rem' }}
        >
          <button
            onClick={() => dispatch(setShowAlertModal({ show: false }))}
            className='btn btn-info'
          >
            Ok
          </button>
        </div>
      </ModalFooter>
    </Modal>
  )
}

export default AlertModal
